import React, { useState, useEffect } from 'react';
import { Menu, Layout, Dropdown, Button } from 'antd';
import { DownOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import logo_deloitte from "../../icons/deloitte.png";
import logo_fse from "../../icons/FSE-logo.png";
import { FaUser } from "react-icons/fa";
import { useAuth } from '../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { IoIosLogOut } from "react-icons/io";
import { SlSettings } from "react-icons/sl";
import { GoAlert } from "react-icons/go";
import { FaBook } from "react-icons/fa";
import { TbTimelineEventText } from "react-icons/tb";
import TransText from "../../translation/trans_tag";
import { HiCursorClick } from "react-icons/hi";
import { IoMdHome } from "react-icons/io";
import { FaUserMd } from "react-icons/fa";

const { Header } = Layout;

const Navbar = (props) => {

  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [activeNav, setActiveNav] = useState('');

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    setShowLogoutModal(false);
    logout();
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  const dropdownItems = [
    {
      key: 'settings',
      // icon: <SlSettings className="icon-size-L me-2 ms-1 d-inline-flex justify-content-start" />,
      label: <a href="/settings" onClick={(e) => { e.preventDefault(); navigate('/settings'); }} style={{ textDecoration: 'none', color: 'inherit' }}>{t('general.navbar.settings')}</a>,
    },
    {
      key: 'issues',
      // icon: <GoAlert className="icon-size-L me-2 ms-1 d-inline-flex justify-content-start" />,
      label: <a href="/issues" onClick={(e) => { e.preventDefault(); navigate('/issues'); }} style={{ textDecoration: 'none', color: 'inherit' }}>{t('general.navbar.issues')}</a>,
    },
    {
      key: 'logout',
      // icon: <IoIosLogOut className="icon-size-L me-2 ms-1 d-inline-flex justify-content-start" />,
      label: t('general.navbar.logout'),
      onClick: handleLogout,
    },
  ];

  // Handler for logo click: redirect based on user role
  const handleLogoClick = () => {
    if (!user) {
      navigate('/login');
    } else if (user.role === 'admin') {
      navigate('/admin');
    } else if (user.role === 'tutor') {
      navigate('/homepage');
    } else {
      navigate('/');
    }
  };

  // Controlla il percorso corrente quando il componente viene montato
  useEffect(() => {
    // Imposta lo stato attivo in base al percorso corrente
    if (location.pathname === '/formazione') {
      setActiveNav('formazione');
    } else {
      setActiveNav('');
    }
  }, [location.pathname]);

  return (
    <Header
      className="custom-header"
    >
      <div className ="d-flex align-items-center justify-content-between w-100">
      <a
        href="/"
        onClick={(e) => {
          e.preventDefault();
          handleLogoClick();
        }}
        className="d-flex align-items-center cursor-pointer"
        style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
      >         

      <img src={logo_deloitte} alt="Logo Deloitte" 
          className="navbar-logo p-2"
            />

          {/* <span className="text-XXXL fw-bold">Regione Toscana</span> */}

        <img src={logo_fse} alt="Logo FSE" 
          className="navbar-logo ms-4"
          />
      </a>

      <div className="d-flex align-items-center flex-row gap-2 gap-xxl-3 ">
              <a 
        href="/homepage"
        className={`d-flex align-items-center ${location.pathname === '/homepage' ? 'color-icon-3' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/homepage');
        }} 
        style ={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
      >
        <IoMdHome className={`me-2align-middle ${location.pathname === '/homepage' ? ' icon-size-XL' : ' icon-size-L '}`} />
      </a>
      <a 
        href="/elenco-discenti"
        className={`d-flex align-items-center nav-button px-1 ${location.pathname === '/elenco-discenti' ? 'active' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/elenco-discenti', {
            state: {
              returnPath: location.pathname !== '/elenco-discenti' ? location.pathname : '/homepage',
              ...location.state // preserve any existing state
            }
          });
        }} 
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        {/* <FaUserMd className="me-1 icon-size-L align-middle" /> */}
        <span className="fs-6 align-middle fw-semibold">
          <TransText i18nKey="general.navbar.discenti" />
        </span>
      </a>
      <a 
        href="/formazione"
        className={`d-flex align-items-center nav-button px-1 ${location.pathname === '/formazione' ? 'active' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/formazione', {
            state: {
              returnPath: location.pathname !== '/formazione' ? location.pathname : '/homepage',
              ...location.state // preserve any existing state
            }
          });
        }} 
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        {/* <FaBook className="me-1 icon-size-L align-middle" /> */}
        <span className="fs-6 align-middle fw-semibold">
          <TransText i18nKey="general.navbar.formazione" />
        </span>
      </a>
      {/* <a 
        href="/guida-tool"
        className={`d-flex align-items-center nav-button px-1 ${location.pathname === '/guida-tool' ? 'active' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/guida-tool', {
            state: {
              returnPath: location.pathname !== '/guida-tool' ? location.pathname : '/homepage',
              ...location.state // preserve any existing state
            }
          });
        }} 
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
       
        <span className="fs-6 align-middle fw-semibold">
          <TransText i18nKey="general.navbar.tutorial" />
        </span>
      </a> */}
      <div className="d-flex align-items-center gap-3">
        <Dropdown
          menu={{
            items: dropdownItems.map(({ key, icon, label, onClick }) => ({
              key,
              icon,
              label: (
                <span
                  className="lh-sm fs-6 py-1 d-flex align-items-center"
                  style={{ cursor: 'pointer' }}
                  onClick={onClick}
                >
                  {label}
                </span>
              ),
              onClick,
            })),
          }}
          trigger={['click']}
          className="d-none d-md-flex align-items-center"
          onOpenChange={(open) => {
            // Imposta activeNav su 'user' solo quando il dropdown è aperto
            setActiveNav(open ? 'user' : '');
          }}
        >
          <div className={`d-flex align-items-center nav-button px-1 user-dropdown ${activeNav === 'user' ? 'active' : ''}`}>
            {/* <FaUser className="me-1 icon-size-L align-middle" /> */}
            <span className="fs-6 align-middle fw-semibold">
              {(() => {
                // Funzione per ottenere le iniziali
                const getInitials = (firstName, lastName) => {
                  // Per il caso di "Alessia Alba", firstName è "Alessia Alba" e lastName è vuoto o altro cognome
                  // Verifichiamo se il firstName contiene spazi (più nomi)
                  let firstNameParts = [];
                  let initials = "";
                  
                  if (firstName) {
                    firstNameParts = firstName.trim().split(/\s+/);
                    // Prendiamo l'iniziale di ogni parte del nome
                    firstNameParts.forEach(part => {
                      if (part && part.length > 0) {
                        initials += part.charAt(0).toUpperCase();
                      }
                    });
                  }
                  
                  // Per il cognome, prendiamo solo la prima lettera del primo cognome
                  if (lastName && lastName.trim()) {
                    const firstLastNamePart = lastName.trim().split(/\s+/)[0]; // Prende solo il primo cognome
                    if (firstLastNamePart && firstLastNamePart.length > 0) {
                      initials += firstLastNamePart.charAt(0).toUpperCase();
                    }
                  }
                  
                  return initials || "";
                };
                
                // Prima prova con i dati utente
                if (user && (user.firstName || user.name || user.lastName || user.surname)) {
                  const firstName = user.firstName || user.name || '';
                  const lastName = user.lastName || user.surname || '';
                  return getInitials(firstName, lastName);
                } else {
                  // Fallback: prova a recuperare dal JWT token
                  const token = localStorage.getItem('token');
                  if (token) {
                    try {
                      const payload = JSON.parse(atob(token.split('.')[1]));
                      const firstName = payload.firstName || payload.name || '';
                      const lastName = payload.lastName || payload.surname || '';
                      return getInitials(firstName, lastName);
                    } catch {
                      return '';
                    }
                  }
                  return '';
                }
              })()}
            </span>
            <DownOutlined className="ms-2 icon-size-M" style={{ cursor: 'pointer' }} />
          </div>
        </Dropdown>
      </div>
      </div>
      </div>
      {/* Modal di conferma logout */}
      <Modal show={showLogoutModal} onHide={cancelLogout} top>
        <Modal.Body>
          <span className="d-flex align-items-center">
            <ExclamationCircleFilled className='icon-alert ms-2 me-2' />
            <span className="fs-5">
              <TransText i18nKey="general.login.logoutTitle" />
            </span>
          </span>
        </Modal.Body>
        <div className="d-flex align-items-center justify-content-end gap-2 p-3 pt-0">
          <Button
            onClick={cancelLogout}
            className='button-responsive fs-5'
          >
            <TransText i18nKey="general.actions.cancel" />
          </Button>
          <Button
            type="primary"
            onClick={confirmLogout}
            className='button-responsive button-color fs-5'
          >
            <TransText i18nKey="general.actions.confirm" />
          </Button>
        </div>
      </Modal>
    </Header>
  );
};

export default Navbar;